<mat-form-field class="w-100 dense-2" [appearance]="appearance()">
  <mat-label>{{ label() }}</mat-label>
  <textarea
    matInput
    [placeholder]="placeholder()"
    [formControl]="formControlRef()"
  >
  </textarea>
</mat-form-field>
